import React from 'react';
import SVGIcon from './SVGIcon';
import { formatNumber } from '../utilities/helpers';
import SelectionNotAvailable from './SelectionNotAvailable';
import DownloadButton from './public/DownloadButton';

const MobileTableGraph = props => {
  const selected = [];
  const [currentIndex, setIndex] = React.useState(0);
  const rowsPerPage = props.rowPerpage;
  const rows = props.data;
  const handleLeftButtonClick = () => {
    setIndex(prevIndex => Math.max(prevIndex - rowsPerPage, 0));
  };

  const handleRightButtonClick = () => {
    if (currentIndex + rowsPerPage < rows.length) {
      setIndex(prevIndex =>
        Math.min(
          prevIndex + rowsPerPage,
          Math.floor(rows.length / rowsPerPage) * rowsPerPage
        )
      );
    }
  };

  const isSelected = name => selected.indexOf(name) !== -1;

  const selectedArray = [];

  rows.forEach(item => {
    selected.some(e => e === item.name) && selectedArray.push(item);
  });

  const cellWidth = (idx, length) => {
    switch (length) {
      case 3:
        return idx === 0 ? { width: '64%' } : { width: '18%' };
      case 4:
        return idx === 0 ? { width: '46%' } : { width: '18%' };

      default:
        break;
    }
  };

  return (
    <React.Fragment>
      {props.isDataAvailable ? (
        <div className="publicTableDiv content-card" style={{ padding: 0 }}>
          <div className="publicTableDiv_title">
            <h6>{props.title}</h6>
          </div>

          <div
            style={{
              display: 'flex',
              float: 'right',
              paddingRight: '2rem',
              paddingTop: '2rem',
            }}
          >
            <div>
              <span className="WhereYourCustomersHaveBeenGraph_top-row_showing">
                Showing {currentIndex + 1} -{' '}
                {Math.min(currentIndex + rowsPerPage, rows.length)} of{' '}
                {rows.length}
              </span>
              <div className="WhereYourCustomersHaveBeenGraph_top-row_button-group">
                <button type="button" onClick={handleLeftButtonClick}>
                  <SVGIcon icon="left-arrow" />
                </button>
                <button type="button" onClick={handleRightButtonClick}>
                  <SVGIcon icon="right-arrow" />
                </button>
              </div>
            </div>

            {props.downloadOpen && (
                <DownloadButton
                    styleObj= { {paddingTop : '0.4rem'} }
                    downloadAudience={props.downloadAudience}
                    downloadingCSV={props.downloadingCSV}
                    reportType={props.reportType}
                    insightType={props.insightType}
                    downloadParams={props.downloadOpen}
                />
            )}
          </div>

          <div>
            <div style={{ paddingTop: '2rem', paddingBottom: '3rem'}}>
              <table>
                <tr className="publicTableDiv_tableRowHead">
                  {props.headCells.map((headCell, idx) => (
                    <td
                      key={headCell.id}
                      className={
                        idx === 0
                          ? 'publicTableDiv_tableRowHead_firstCell'
                          : 'publicTableDiv_tableRowHead_nthCell'
                      }
                      style={cellWidth(idx, props.headCells.length)}
                    >
                      {headCell.label}
                    </td>
                  ))}
                </tr>
                <tbody>
                  {rows
                    .slice(currentIndex, currentIndex + rowsPerPage)
                    .map((row, index) => {
                      const isItemSelected = isSelected(row.name);
                      return (
                        <tr
                          // onClick={event => handleClick(event, row.name)}
                          key={row.name}
                          className={
                            isItemSelected
                              ? 'publicTableDiv_tableRowBody_selected'
                              : 'publicTableDiv_tableRowBody'
                          }
                        >
                          {props.headCells.map((headCell, idx) => (
                            <td
                              key={headCell.id}
                              className={
                                idx === 0
                                  ? 'publicTableDiv_tableRowBody_firstCell'
                                  : 'publicTableDiv_tableRowBody_nthCell'
                              }
                              style={cellWidth(idx, props.headCells.length)}
                            >
                              {headCell.id === 'name'
                                ? row.name
                                : headCell.id === 'percentage'
                                ? row.percentage < 0.01
                                  ? `< 0.01%`
                                  : `${row.percentage.toFixed(2)}%`
                                : headCell.id === 'count'
                                ? formatNumber(row.count)
                                : headCell.id === 'devices'
                                ? formatNumber(row.devices)
                                : ``}
                            </td>
                          ))}
                        </tr>
                      );
                    })}

                </tbody>
              </table>
            </div>
          </div>
        </div>
      ) : (
        <SelectionNotAvailable
          text="Graph Currently Unavailable"
          buttonText=""
        />
      )}
    </React.Fragment>
  );
};

export default MobileTableGraph;
